import { Component } from '@angular/core';
@Component({
  selector: 'not-permitted',
  template: '<h3>Error 403: Forbidden</h3>'
})

export class PermissionDeniedPage { }
